var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"gamescores"}},[_vm._m(0),_c('gameScoresTable',{attrs:{"id":"gameScoresTable","scores":_vm.scores,"users":_vm.users}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"page-title"},[_c('i',{staticClass:"fal fa-gamepad"}),_vm._v(" Mini-Jeu Weezy\n      ")])])])
}]

export { render, staticRenderFns }